import { InputBase } from './input-base'

export class InputTextbox extends InputBase<string> {
  controlType = 'textbox'
}
